import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

LP.dlgItemFilter = {
  prepare: function (selector, params) {
    var orgParams = $.extend(true, {}, params);
    $(selector).click(function () {
      var $this = $(this);
      if (!$this.is('[disabled]')) {
        var urlParams = $this.attr('url_params');
        var filterId = $this.attr('filter-id');
        if (filterId) {
          urlParams += '&filter=' + filterId;
        }

        var f_afterSubmit = function (json) {
          if (json.filterId) {
            $this.attr('filter-id', json.filterId);
          } else {
            $this.removeAttr('filter-id');
          }

          if (orgParams.afterSubmit && is_function(orgParams.afterSubmit)) {
            return orgParams.afterSubmit(json);
          }

          return true;
        };

        LP.Dialog.open(
          $.extend(params, {
            name: 'itemFilter',
            ajax: 'backend/itemFilterDialog',
            request: urlParams,
            title: this.title,
            width: 800,
            height: 400,
            sizeable: true,
            onLoad: LP.dlgItemFilter.onLoad,
            afterSubmit: f_afterSubmit,
          })
        );
      }
      return false;
    });
  },

  onLoad: function (root) {
    LP.filters.init({root: '#' + root.attr('id')});
  },
};
